import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-asset',
  templateUrl: './view-asset.component.html',
  styleUrls: ['./view-asset.component.css']
})
export class ViewAssetComponent implements OnInit {

  asset_name: string;
  main_acct_name: string;
  asset_number: string;

  private dp = [];
  displayedColumns = ['year', 'depreciation_value', 'value_after_depr', 'depr_percent', 'remaining_years'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<ViewAssetComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);
  }

  ngOnInit() {
    this.asset_name = this.dialog_data['asset_name'];
    this.main_acct_name = this.dialog_data['main_acct_name'];
    this.asset_number = this.dialog_data['asset_number'];

    let remaining_years = Number(this.dialog_data['def_age']) - Number(this.dialog_data['service_year']);

    this.dp.push({
      'year': this.dialog_data['service_year'], 'depreciation_value': this.dialog_data['depreciation_value'],
      'value_after_depr': this.dialog_data['book_value'], 'depr_percent': this.dialog_data['depr_percent'], 'remaining_years': remaining_years
    });
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
